<script lang="ts">
    import { getBrowserInfo, getBrowserDisplayName } from "../../Utils/BrowserCompatibility";
    import { LL } from "../../../i18n/i18n-svelte";

    let browserInfo = getBrowserInfo();
    let browserName = getBrowserDisplayName();

    function handleUpdateBrowser() {
        window.open(browserInfo.updateUrl, "_blank", "noopener,noreferrer");
    }

    function handleLeave() {
        // Try to go back, or close the window/tab
        if (window.history.length > 1) {
            window.history.back();
        } else {
            window.close();
        }
    }
</script>

<div class="fixed inset-0 z-9999 flex items-center justify-center bg-contrast-1100">
    <!-- Background image layer (like PictureInPicture) -->
    <div
        class="fixed z-9998 top-0 left-0 w-full h-full bg-no-repeat bg-contain bg-center bg-[#F1F0EB]"
        style="background-image: url(/static/images/map-bg.svg);"
    ></div>
    <!-- Background color overlay -->
    <div
        class="bg-mlight/80 shadow-light rounded-md2 z-10000 w-[90%] m-auto left-0 right-0 sm:max-w-[600px] max-h-full overflow-y-auto pointer-events-auto"
    >
        <div class="p-8 flex flex-col justify-center items-center">
            <div class="mb-3">
                <h2 class="text-2xl leading-8 font-bold text-center">
                    {$LL.warning.browserNotSupported.message({ browserName })}
                </h2>
                <!-- Note: We don't show close button as user must update or leave -->
            </div>

            <div class="w-full space-y-4">
                <p class="m-0 text-center">{$LL.warning.browserNotSupported.description()}</p>
            </div>
            <div class="flex flex-row justify-evenly items-center w-full mt-6 gap-3">
                <button
                    class="btn btn-secondary flex-1"
                    onclick={handleUpdateBrowser}
                    data-testid="update-browser-button"
                >
                    {$LL.warning.browserNotSupported.updateBrowser()}
                </button>
                <button class="btn btn-light flex-1" onclick={handleLeave} data-testid="leave-button">
                    {$LL.warning.browserNotSupported.leave()}
                </button>
            </div>
            <!-- <div class="flex gap-1 flex-row mt-6">
                <button class="btn btn-primary">Button</button>
                <button class="btn btn-primary" disabled>Button</button>
                <button class="btn btn-danger">Button</button>
                <button class="btn btn-warning">Button</button>
                <button class="btn btn-success">Button</button>
                <button class="btn btn-light">Button</button>
                <button class="btn btn-contrast">Button</button>
                <button class="btn btn-neutral">Button</button>
            </div>
            <div class="flex gap-1 flex-row mt-6">
                <button class="btn btn-primary btn-border">Button</button>
                <button class="btn btn-primary btn-border" disabled>Button</button>
                <button class="btn btn-danger btn-border">Button</button>
                <button class="btn btn-warning btn-border">Button</button>
                <button class="btn btn-success btn-border">Button</button>
                <button class="btn btn-light btn-border">Button</button>
                <button class="btn btn-contrast btn-border">Button</button>
                <button class="btn btn-neutral btn-border">Button</button>
            </div>
            <div class="flex gap-1 flex-row mt-6">
                <button class="btn btn-primary btn-ghost">Button</button>
                <button class="btn btn-primary btn-ghost" disabled>Button</button>
                <button class="btn btn-danger btn-ghost">Button</button>
                <button class="btn btn-warning btn-ghost">Button</button>
                <button class="btn btn-success btn-ghost">Button</button>
                <button class="btn btn-light btn-ghost">Button</button>
                <button class="btn btn-contrast btn-ghost">Button</button>
                <button class="btn btn-neutral btn-ghost">Button</button>
            </div>
            <div class="flex gap-1 flex-col mt-6 items-start">
                <button class="btn btn-primary self-start">Button</button>
                <button class="btn btn-primary btn-lg self-start">Button</button>
                <button class="btn btn-primary btn-sm self-start">Button</button>
                <button class="btn btn-primary btn-xs self-start">Button</button>
            </div> -->
        </div>
    </div>
</div>

<style>
    :global(body) {
        overflow: hidden;
    }
</style>
